export class Appellation {

    constructor(readonly name: string) {
    }
}



// WEBPACK FOOTER //
// ./src/api/request/Appellation.ts